import type { ReactElement, ReactNode } from "react";

import { usePageMeta } from "../app/use-page-meta.js";

/**
 * 読むだけの画面（「確認メールをお送りしました」など）。面は <c>panel-message</c>。
 */
export function MessagePage({ title, children, actions }: {
    readonly title: string;
    readonly children?: ReactNode;
    readonly actions?: ReactNode;
}): ReactElement {
    usePageMeta(title);

    return (
        <div className="page max-w-lg">
            <div className="panel-message">
                <h1 className="page-title">{title}</h1>
                {children === undefined ? null : <p className="page-lead">{children}</p>}
                {actions}
            </div>
        </div>
    );
}
